export default {
    csManagement: {
        page: {
            title: 'CS 管理中心',
            description: '管理租户配额、文档总量和 Token 消耗控制',
        },
        quota: {
            searchPlaceholder: '搜索租户 ID',
            typePlaceholder: '配额类型',
            search: '搜索',
            create: '新增配额',
            tenantId: '租户 ID',
            quotaType: '配额类型',
            typeDocument: '文档总量',
            typeToken: 'Token 消耗总量',
            quotaLimit: '配额上限',
            quotaUsed: '已使用',
            contractPeriod: '合同期',
            contractStart: '合同开始',
            contractEnd: '合同结束',
            status: '状态',
            statusActive: '生效中',
            statusExpired: '已过期',
            remark: '备注',
            action: '操作',
            edit: '编辑',
            delete: '删除',
            createTitle: '新增配额',
            editTitle: '编辑配额',
            cancel: '取消',
            confirm: '确认',
            saving: '保存中...',
            featureConfig: '功能配置',
            featureConfigTitle: '功能权限配置',
            featureDisclosure: '交底书',
            featureDisclosureDesc: '发明交底书撰写功能',
            featurePatentDraft: '专利申请',
            featurePatentDraftDesc: '专利申请文件撰写功能',
            featureProsecution: 'OAR答复',
            featureProsecutionDesc: '审查意见答复撰写功能',
            userQuotaTitle: '用户配额明细',
            userQuotaHint: '公司配额上限：{limit} 次',
            userEmail: '用户邮箱',
            unlimited: '不限制',
            addUser: '添加用户',
            addUserPlaceholder: '输入用户邮箱',
            reset: '清除',
            tenantName: '公司名称',
            configuredMembers: '已配置员工',
            noConfiguredMembers: '该公司暂无已配置员工',
            tenantInfoNotFound: '未找到该公司',
            tenantInfoFailed: '查询失败，请稍后重试',
            featureList: '功能清单',
            featureAll: '全部',
        },
    },
}
